export enum PlaylistType {
  WEBINAR = "1",
  KAKI_MAKAN = "2",
  SHORT_FORM = "3",
  PORTRAIT_VIDEO = "4",
}
